export default {
  eoDashboard: {
    breadcrumbsTitle: 'Dashboard',
    messages: {
      cantFetchEoDashboardMetrics: "Can't load Email Outreach dashboard metrics",
    },
  },
};
